import React, { useState, useEffect } from 'react';
import { doc, updateDoc, getFirestore } from 'firebase/firestore';
import { fetchUserProfile2 } from './services/api';


function Profile({ onLogout, onPageChange, enableNotifications }) {
    // Initialize profile state to an empty object if local storage is not set

    const [savedProfile, setSavedProfile] = useState(JSON.parse(localStorage.getItem('profile')) || {});

    useEffect(() => {
        const getProfile = async () => {
            try {
                const u = await fetchUserProfile2(savedProfile.Email, setSavedProfile);

                setNewName(u.Name);
                setIcon(u.Icon);
                setColor(u.Color);
            }
            catch {

            }
        }
        getProfile();
    }, []);

    const [updating, setUpdating] = useState(false);
    const [newName, setNewName] = useState(savedProfile.Name || '');
    const [color, setColor] = useState(savedProfile.Color || '');
    const [icon, setIcon] = useState(savedProfile.Icon || '');

    const updateProfile = async (email) => {
        try {
            setUpdating(true);
            const firestore = getFirestore();

            // Reference the document using the email as the document ID
            const userDocRef = doc(firestore, 'Users', email);

            // Update the document with the new name and picture
            await updateDoc(userDocRef, {
                Name: newName,
                Color: color,
                Icon: icon
                // Add any other fields you want to update
            });

            // Update localStorage and state accordingly
            localStorage.setItem('profile', JSON.stringify({
                Email: email,
                Name: newName,
                Color: color,
                Icon: icon
            }));
            setSavedProfile({
                Email: email,
                Name: newName,
                Color: color,
                Icon: icon
                // Add any other fields you want to update
            });

        } catch (error) {
            console.error('Error updating profile:', error);
        } finally {
            setUpdating(false);
        }
    };

    useEffect(() => {
        const handleStorageChange = () => {
            setSavedProfile(JSON.parse(localStorage.getItem('profile')));
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    //const pictureUrl = savedProfile.Picture ? savedProfile.Picture.replace('public\\', '') : ''; // Check if Picture field is available

    const handleIconSelect = (icon) => {
        setIcon(icon);
    };

    const handleColorSelect = (color) => {
        setColor(color);
    };

    const isUpdateEnabled = true;

    const iconList = ['football', 'stadium', 'gibbsgrey', 'pizza', 'brain', 'camel', 'plant', 'trex', 'ufo', 'bomb', 'diamond', 'cash', 'fall', 'orca', 'shark', 'frank', 'flamingo', 'snowman'];
    const colorList = [
  'darkyellow', 'grey1', 'black',
  'red', 'red1', 'red2',
  'orange', 'orange1', 'orange2',
  'yellow', 'yellow2', 'yellow3',
  'green', 'green2', 'green3',
  'blue', 'blue1', 'blue2',
  'dblue', 'dblue1', 'dblue2',
  'purple', 'purple1', 'purple2',
  'pinky', 'pink1', 'pink2',
  'special', 'special1', 'special2',
  'red49'
];

    return (
        <div className="profile page">

            <div className="profile-section">
                <h2>Manage Your Profile</h2>
                <div className="displayName">
                    <span className="title">Display Name</span>
                    <input type="text" value={newName} onChange={(e) => setNewName(e.target.value)} />
                </div>
                <div className="emailAddress">
                    <span className="title">Email</span>
                    <div className="disabledField">{savedProfile.Email}</div>
                </div>
                <div className="profilePic">
                    <span className="title">Profile Picture</span>
                    <div className="Field">
                        {icon && <div id="actualIcon" className={`actualIcon ${color}`}><img src={`${icon}.png`} alt={`${icon}`}/></div>}
                       

                        <div className="icons">
                          {iconList.map((iconName) => (
                            <div
                              key={iconName}
                              className={`icon ${iconName} ${icon === iconName ? 'active' : ''}`}
                              onClick={() => handleIconSelect(iconName)}
                            >
                              <img src={`${iconName}.png`} alt={iconName} />
                            </div>
                          ))}
                        </div>


                        <div className="colors">
                          {colorList.map((colorName) => (
                            <div
                              key={colorName}
                              className={`color ${colorName} ${color === colorName ? 'active' : ''}`}
                              onClick={() => handleColorSelect(colorName)}
                            ></div>
                          ))}
                        </div>

                    </div>
                </div>
                <button disabled={!isUpdateEnabled || updating} onClick={() => updateProfile(savedProfile.Email)}>
                    {updating ? 'Updating...' : 'Update'}
                </button>
            </div>
            <br />
            
            <button id="logout" onClick={onLogout}>Logout of GIBBS</button>
           {savedProfile.Email == "bennyalash@gmail.com" && <button id="logout2" onClick={() => onPageChange('notification')}>Send Notification</button>}
           {/*<div id="enable-notifications" className="enable-notes-prof">
                <h3>Enable Notifications</h3>
                <p>Please enable notifications for important reminders and alerts</p>
                <button onClick={() => enableNotifications()}>Allow</button>
            </div>*/}
        </div>
    );
}

export default Profile;
